
// import activityFooter from 'https://s21.lgstatic.com/growth/activity/20210125/1611561198944.png';
// import pcActivity1 from 'https://s21.lgstatic.com/growth/activity/20210125/1611561135344.png';
// import pcActivity2 from 'https://s21.lgstatic.com/growth/activity/20210125/1611561149885.png';
// import pcActivity3 from 'https://s21.lgstatic.com/growth/activity/20210125/1611561164185.png';
export const footerCom = {
    data() {
        return {
            activityFooter: 'https://s21.lgstatic.com/growth/activity/20210125/1611561198944.png', // 618底部按钮
            pcActivity1: 'https://s21.lgstatic.com/growth/activity/20210125/1611561135344.png',
            pcActivity2: 'https://s21.lgstatic.com/growth/activity/20210125/1611561149885.png',
            pcActivity3: 'https://s21.lgstatic.com/growth/activity/20210125/1611561164185.png',
            footerBtn: {}, // 底部按钮显隐控制
            is618: false,
        };

    },
    mounted() {
        // if (new Date(2020, 5, 11) > new Date()) {
        //     this.is618 = true;
        //     if (this.isPc) {
        //         this.footerBtn = {
        //             'background-color': '#fff',
        //             'background-position': 'center',
        //             'background-size': 'cover',
        //             'width': '100%',
        //             'height': '80PX',
        //             'padding': '0',
        //             'margin': '0',
        //      };
        //         if (new Date(2020, 5, 17) > new Date()) {
        //             this.footerBtn['background-image'] = `url(${pcActivity3})`;
        //         } else if (new Date(2020, 5, 18) > new Date()) {
        //             this.footerBtn['background-image'] = `url(${pcActivity2})`;
        //         } else if (new Date(2020, 5, 19) > new Date()) {
        //             this.footerBtn['background-image'] = `url(${pcActivity1})`;
        //         }
        //     } else {
        //         this.footerBtn = { 'background-image': `url(${activityFooter})`, 'height': '1.68rem' };
        //     }
        // }

    },
};